export default __webpack_public_path__ + "static/media/testimony2.97733457.png";